import { render, staticRenderFns } from "./AddServicoModal.vue?vue&type=template&id=119f3f36&scoped=true&"
import script from "./AddServicoModal.vue?vue&type=script&lang=js&"
export * from "./AddServicoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119f3f36",
  null
  
)

export default component.exports